module.exports = __webpack_public_path__ + "static/media/big-not-active-karma.1a588b80.svg";